import { render, staticRenderFns } from "./AllTickets.vue?vue&type=template&id=2939665a&scoped=true"
import script from "./AllTickets.vue?vue&type=script&lang=js"
export * from "./AllTickets.vue?vue&type=script&lang=js"
import style0 from "./AllTickets.vue?vue&type=style&index=0&id=2939665a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2939665a",
  null
  
)

export default component.exports